import { Pipe, PipeTransform } from '@angular/core';
import { GeschaeftsnummerEntry } from '../../../core/gb-api';
import { GeometergeschaeftsnummerEntry } from '../../../core/av-api';

@Pipe({
  name: 'formatGeometergeschaeftsnummer'
})
export class FormatGeometergeschaeftsnummerPipe implements PipeTransform {
  private ANZAHL_STELLEN = 6;

  constructor() {}

  transform(geschaeftsnummer: GeschaeftsnummerEntry | GeometergeschaeftsnummerEntry): any {
    if (!geschaeftsnummer) {
      return;
    }
    return (
      geschaeftsnummer.jahr +
      '/' +
      (geschaeftsnummer.nummer + Math.pow(10, this.ANZAHL_STELLEN) + '').slice(1) +
      '/' +
      geschaeftsnummer.index
    );
  }
}
